import * as Yup from "yup";

export const AddOrEditProductCardSchema = Yup.object().shape({
  name: Yup.string().nullable().required("product-card.name-validation"),
  process_steps: Yup.array()
    .min(1, "product-card.process-steps-validation")
    .required("product-card.process-steps-validation"),
});
